export default __webpack_public_path__ + "images/41_1_image.jpg";